import { LegalPage } from "@/components/LegalPage";
import { REFUND } from "@/data/legal";

export default function Refund() {
  return <LegalPage policy={REFUND} />;
}
